module.exports = __webpack_public_path__ + "img/private.3cd6d0c6.svg";